var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.0001,
    r: 21.5,
    fill: "white",
    stroke: "url(#paint0_linear_9_10198)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0381 22.4066C31.0381 21.6484 30.977 21.0951 30.8447 20.5213H22.2421V23.9435H27.2916C27.1899 24.794 26.6401 26.0748 25.4184 26.9355L25.4013 27.0501L28.1213 29.1708L28.3097 29.1898C30.0404 27.5811 31.0381 25.2141 31.0381 22.4066Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2192 31.4207C24.6973 31.4207 26.7777 30.6014 28.2973 29.1882L25.401 26.9352C24.626 27.478 23.5857 27.8569 22.2192 27.8569C19.792 27.8569 17.732 26.2492 16.9976 24.0269L16.89 24.0361L14.0568 26.2379L14.0198 26.3413C15.5291 29.352 18.6294 31.4207 22.2192 31.4207Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 24.0164C16.8189 23.4452 16.7051 22.8332 16.7051 22.2009C16.7051 21.5684 16.8189 20.9565 17.0052 20.3853L17 20.2636L14.0888 18.0355L13.9935 18.0801C13.3622 19.3245 13 20.7219 13 22.2009C13 23.6798 13.3622 25.0771 13.9935 26.3215L17.0156 24.0164Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2206 16.5638C23.9444 16.5638 25.1072 17.3113 25.7702 17.9361L28.3611 15.3964C26.7699 13.9115 24.6992 13.0001 22.2206 13.0001C18.6302 13.0001 15.5294 15.0687 14.0198 18.0794L16.988 20.3938C17.7327 18.1716 19.7931 16.5638 22.2206 16.5638Z",
    fill: "#EB4335"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_10198",
    x1: 22,
    y1: 0.0000610352,
    x2: 22,
    y2: 44.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279167,
    stopColor: "#FBBC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648958,
    stopColor: "#34A853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4e10e6fc2c7edd672afa4c55d60995c6.svg";
export { ForwardRef as ReactComponent };